"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const card_1 = require("./card");
const pile_1 = require("./pile");
class Table {
    constructor(table, gameParams) {
        this.gameParams = gameParams;
        // NB: why does fromEntries need `as`
        this.table = Object.fromEntries(card_1.getAllColors(gameParams).map(color => [color, new pile_1.Pile(table ? table[color] : [])]));
    }
    getScore() {
        return Object.values(this.table)
            .map(p => p.cards)
            .flat().length;
    }
    toJSON() {
        // NB: why does fromEntries need `as`
        return Object.fromEntries(Object.entries(this.table).map(([c, pile]) => [c, pile.toJSON()]));
    }
    getCards() {
        return Object.values(this.table)
            .map(p => p.cards)
            .flat();
    }
    has(card) {
        return !!this.table[card.color].cards.find(c => c.num === card.num);
    }
    // returns whether the card could be successfully played
    isPlayable(card) {
        return card.color === 'K'
            ? this.table[card.color].size === 5 - card.num
            : this.table[card.color].size === card.num - 1;
    }
    // returns new pile size if the card was successfully played,
    // and false if not
    play(card) {
        const colorPile = this.table[card.color];
        if (this.isPlayable(card)) {
            colorPile.add(card);
            return colorPile.size === card_1.AllNums.length ? 'SUCCESS_CLOSED' : 'SUCCESS_PENDING';
        }
        else {
            return 'FAILURE';
        }
    }
}
exports.Table = Table;
//# sourceMappingURL=table.js.map